import * as RadixToast from '@radix-ui/react-toast';
import type { PropsWithChildren } from 'react';
import { Toast, ToastViewport } from '~/components/granular';
import { useToast, useToasts } from '~/global-state/toast';

export { useToast } from '~/global-state/toast';

export const ToastRenderer = ({ children }: PropsWithChildren) => {
  const toasts = useToasts();
  const { removeToast } = useToast();

  return (
    <RadixToast.Provider swipeDirection="right">
      {children}
      {(toasts ?? []).map((toast) => (
        <Toast
          appearance={toast.appearance}
          copyText={toast.copyText}
          description={toast.description}
          id={toast.id}
          key={toast.key}
          onOpenChange={(open) => !open && removeToast(toast.id)}
          title={toast.title}
        />
      ))}
      <ToastViewport />
    </RadixToast.Provider>
  );
};
